import { ActionType, createAction } from 'typesafe-actions'

import { LogItem } from './types'

export const LogActions = {
  addLogItem: createAction('LOGS/add-log-item')<LogItem>()
}

export type LogActions = ActionType<typeof LogActions>
